var uiBreakdown = {
	table: {
		caption: "Desgloses",
		weight: "Peso %",
		name: "Nombre",
		noItems: "No se encontraron resultados"
	},
	chart: {
		counting: "Desgloses",
		topPositions: "Posiciones destacadas",
		others: "Otros"
	}
};
var es = {
	uiBreakdown: uiBreakdown
};

export { es as default, uiBreakdown };
